import {IDataLayerEvent, IAlgoliaEventData} from '../IAlgoliaManager';

/**
 * Represents EventModel
 */
export default class EventModel implements IDataLayerEvent {
	public data: IAlgoliaEventData;
	/**
	 * @constructor
	 * @param {IAlgoliaEventData} data - data
	 */
	constructor(data: IAlgoliaEventData) {
		if (data) {
			const {
				eventName,
				searchQueryID,
				indexName,
			} = data;

			this.data = {
				eventName: eventName,
				index: indexName,
				queryID: searchQueryID
			};
		}
	}
};
